/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import cx from 'clsx';
import React from 'react';

import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { IconButton, TableCell, TableRow } from '@mui/material';

import { useTableStyles } from '../../../../../../../../styles/table';
import { useDatasetImportsTableDatabaseHeadingStyles } from './DatasetImportsTableDatabaseHeading.styles';

type DatasetImportsTableDatabaseHeadingProps = {
  databaseName: string;
  onCollapseIconClick: () => any;
  collapsed: boolean;
  showCollapseBtn: boolean;
};

export function DatasetImportsTableDatabaseHeading(props: DatasetImportsTableDatabaseHeadingProps) {
  const { databaseName, onCollapseIconClick, collapsed, showCollapseBtn } = props;
  const tableClasses = useTableStyles();
  const classes = useDatasetImportsTableDatabaseHeadingStyles();

  return (
    <TableRow>
      <TableCell
        classes={{
          root: cx(tableClasses.bodyTableCell, classes.cell, classes.collapseIconButtonCell),
        }}
      >
        {showCollapseBtn && (
          <IconButton className={classes.collapseIconButton} onClick={onCollapseIconClick} size="large">
            {!collapsed ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        )}
      </TableCell>
      <TableCell
        classes={{
          root: cx(tableClasses.bodyTableCell, classes.cell, classes.databaseNameCell),
        }}
        colSpan={99}
      >
        {databaseName}
      </TableCell>
    </TableRow>
  );
}
